export default {"src":"/_next/static/media/img-support_agent.f8c71bdb.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};